<form #f="ngForm">
    <div class="p-grid">
        <div class="p-col-12 error-notify-text">
            <app-validateform [formToValidate]="territoryAddForm"></app-validateform>
        </div>
    </div>
    <div class="p-grid">
        <div class="p-col-12 page-header">Territories</div>
        <div class="p-col-12 divider-header">
            <p-divider></p-divider>
        </div>
        <div class="p-col-12 p-lg-2 p-md-2">
            <p-button styleClass="fullwidthbtn" label="Back" routerLink="/member/{{member.Id}}"></p-button>
        </div>
        
    </div>
    <div class="p-grid">

        <div class="p-col-12 p-lg-6 p-md-6">
            <div class="p-inputgroup">
                <input type="text"
                    pInputText
                    (keydown.enter)="$event.preventDefault()" 
                    placeholder="Enter Area"
                    autocorrect="off"
                    autocapitalize="off"
                    spellcheck="off"
                    type="text"
                    #searchArea
                    name="Area"                    
                    data-display-name="Area"
                   >

            </div>
        </div>   
        
        
            <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom">
                <agm-marker [latitude]="latitude" [longitude]="longitude" [markerDraggable]="true"
                ></agm-marker>          
                <agm-kml-layer [url]="kmlurl" [preserveViewport]="false"> </agm-kml-layer>     
            </agm-map>          
        
            <div class="p-col-12 p-lg-4 p-md-4">
                <span class="p-float-label">
                    <p-dropdown inputId="dropdown"
                                [autoDisplayFirst]="false"
                                [showClear]="true"
                                [options]="countryOptions"
                                [(ngModel)]="territory.CountryCode"
                                appendTo="body"
                                required             
                                data-display-name="Country"                   
                                name="Country">
                    </p-dropdown>
                    <label for="dropdown">Country</label>
                </span>
            </div>
            <div class="p-col-12 p-lg-4 p-md-4">
                <span class="p-float-label">
                    <p-dropdown inputId="dropdown"
                                [autoDisplayFirst]="false"
                                [showClear]="true"
                                [options]="granularityLevels"
                                [(ngModel)]="territory.Level"
                                appendTo="body"
                                name="Level"
                                data-display-name="Level"
                                required 
                            >
                    </p-dropdown>
                    <label for="dropdown">Level</label>
                </span>
            </div>     
            <div class="p-col-12 p-lg-4 p-md-4">
                <button pButton type="button" label="Add" (click)="addterritory()"></button>    
            </div>
            
    </div>
</form>
<div class="card">
    <div class="p-grid">               
        <div class="p-col-12">
            <p-table [value]="territories" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th><b></b></th>
                        <th><b></b></th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-territory>
                    <tr>
                        <td>{{territory.TerritoryName}}</td>
                        <td>{{territory.FormattedAddress}}</td>
                        <td style="text-align: right">
                            <button pButton type="button" class="p-button-primary" label="Remove" (click)="deleteterritory(territory)"></button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
 <!-- <p-dialog [breakpoints]="{'960px': '200vw'}" styleClass="dialog-medium" draggable="false" modal="true" [closable]="false" header="Add Territory" [(visible)]="addTerritoryDialogVisible">
    <p-divider></p-divider>
    <div class="p-grid">

        <div class="p-col-12 p-lg-6 p-md-6">
            <div class="p-inputgroup">
                <input type="text"
                       pInputText
                       (keydown.enter)="$event.preventDefault()" 
                        placeholder="Enter Location"
                       autocorrect="off"
                       autocapitalize="off"
                       spellcheck="off"
                        type="text"
                        #searchArea
                       [(ngModel)]="territory.Address">
            </div>
            </div>
        
          
          
            <agm-map [latitude]="latitude" [longitude]="longitude" [zoom]="zoom">
                <agm-marker [latitude]="latitude" [longitude]="longitude" [markerDraggable]="true"
                ></agm-marker>               
            </agm-map>          
         
          <div class="p-col-12">
            <span class="p-float-label">
                <p-dropdown inputId="dropdown"
                            [autoDisplayFirst]="false"
                            [showClear]="true"
                            [options]="countryOptions"
                            [(ngModel)]="territory.CountryCode"
                            appendTo="body"
                            name="Country">
                </p-dropdown>
                <label for="dropdown">Country</label>
            </span>
            <span class="p-float-label">
                <p-dropdown inputId="dropdown"
                            [autoDisplayFirst]="false"
                            [showClear]="true"
                            [options]="granularityLevels"
                            [(ngModel)]="territory.Level"
                            appendTo="body"
                            name="Level"
                           >
                </p-dropdown>
                <label for="dropdown">Level</label>
            </span>
        </div>       
    </div>
    <ng-template pTemplate="footer">
        <button pButton type="button" label="Add" (click)="addterritory()"></button>           
        <button pButton type="button" label="Cancel" (click)="hideAddTerritoryDialog()"></button>
    </ng-template>
</p-dialog>  -->

<p-confirmDialog header="Confirmation" icon="ui-icon-warning" width="800"></p-confirmDialog>
